import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class GuidanceStepNextStepsClickEventTracking extends BaseEventTracking {
  /**
   * @var {string}
   */
  static eventName = SegmentEvent.GUIDANCESTEP_STEPS_CLICKED;

  /**
   * @var {number}
   */
  userId;

  /**
   * @var {string}
   */
  userName;

  /**
   * @var {string}
   */
  userRole;

  constructor(authUser) {
    super();
    this.userId = authUser.id;
    this.userName = authUser.name;
    this.userRole = authUser.estateAccount?.roleName ?? authUser.roleName;
  }
}
